import './global.css';

const darkThemeConfig = {
  components: {
    Button: {
      borderRadius: 0,
      borderRadiusLG: 0,
      borderRadiusSM: 0,
      paddingXS: 12,
      paddingInline: 16,
      paddingInlineLG: 16,
      paddingInlineSM: 16,
      contentFontSize: 16,
      contentFontSizeSM: 12,
      controlHeight: 48,
      paddingBlock: 12,
      paddingBlockLG: 12,
      fontSize: 16,
      controlHeightLG: 48,
      controlHeightSM: 40,
      primaryColor: 'var(--selected-text-color, #000000)',
      colorPrimary: 'var(--button-default-bg-color, #007BC0)',
      colorPrimaryHover: 'var(--button-primary-hover-color, #56B0FF)',
      colorPrimaryActive: 'var(--button-primary-selected-color, #9DC9FF)',
      colorPrimaryBorder: 'var(--button-default-bg-color, #007BC0)',
      colorTextDisabled: 'var(--button-default-disabled-text-color, #595E62)',
      colorBgContainerDisabled: 'transparent',
      borderColorDisabled: 'var(--button-default-disabled-text-color, #595E62)',
      colorBorder: 'var(--button-default-bg-color, #007BC0)',
      defaultBg: 'transparent',
      defaultColor: 'var(--button-default-text-color, #56B0FF)',
      defaultBorderColor: 'var(--button-default-text-color, #56B0FF)',
      defaultHoverBorderColor:
        'var(--button-default-hover-text-color, #9DC9FF)',
      defaultHoverBg: 'var(--button-default-hover-bg-color, #004975)',
      defaultHoverColor: 'var(--button-default-hover-text-color, #9DC9FF)',
      defaultActiveColor: 'var(--button-default-active-text-color, #D1E4FF)',
      defaultActiveBg: 'var(--button-default-active-bg-color, #00629A)',
      defaultActiveBorderColor:
        'var(--button-default-active-text-color, #D1E4FF)',
      colorLink: 'var(--button-default-bg-color, #007BC0)',
      colorLinkActive: 'var(--button-default-bg-color, #007BC0)',
      colorLinkHover: 'var(--button-default-bg-color, #007BC0)',
      textHoverBg: 'transparent',
      dangerShadow: '0',
      defaultShadow: '0',
      primaryShadow: '0',
    },
    Layout: {
      headerBg: 'var(--body-bg-color, #000000)',
      footerBg: 'var(--primary-fill-color, #1A1C1D)',
      bodyBg: 'var(--content-bg-color, #000000)',
      bodyColor: 'var( --primary-text-color, #FFFFFF)',
      headerColor: 'var( --primary-text-color, #FFFFFF)',
      footerColor: 'var( --primary-text-color, #FFFFFF)',
      footerPadding: '0.5rem 2rem',
      siderBg: '#2E3033',
    },
    Divider: {
      colorSplit: '#8A9097',
      margin: 0,
      marginLG: 0,
    },
    Menu: {
      itemBg: '#2E3033',
      itemSelectedColor: 'var(--primary-text-color, #ffffff)',
      itemSelectedBg: 'var(--content-bg-color, #000000)',
      itemMarginInline: 0,
      itemMarginBlock: 0,
      activeBarBorderWidth: 0,
      collapsedWidth: '3rem',
      itemHeight: '3rem',
      iconSize: '1.5rem',
      itemColor: '#FFFFFF',
      itemHoverColor: '#FFFFFF',
      itemHoverBg: '#43464a',
    },
    List: {
      itemPadding: 0,
    },
    Pagination: {
      itemActiveBg: 'var(--button-default-bg-color, #007BC0) !important',
      itemBg: 'transparent !important',
      colorPrimary: 'var(--selected-text-color, #000000)',
      colorPrimaryHover: '#FFFFFF',
      borderRadius: 16,
      fontWeightStrong: 400,
      lineWidth: 0,
    },
    Table: {
      colorBgContainer: 'var(--primary-fill-color, #1A1C1D)',
      headerBg: 'var(--primary-fill-color, #1A1C1D)',
      headerColor: 'var( --primary-text-color, #FFFFFF)',
      cellFontSize: 16,
      rowExpandedBg: 'var(--selected-bg-color, #D0D4D8)',
      headerBorderRadius: 1,
      borderColor: '#71767C',
      headerSplitColor: 'var(--primary-fill-color, #1A1C1D)',
      bodySortBg: 'var(--primary-fill-color, #1A1C1D)',
      headerSortActiveBg: 'var(--primary-fill-color, #1A1C1D)',
      headerSortHoverBg: 'var(--primary-fill-color, #1A1C1D)',
      rowHoverBg: 'var(--table-row-hover-bg-color, #2E3033)',
      rowSelectedBg: 'var(--selected-bg-color, #D0D4D8)',
      colorText: 'var( --primary-text-color, #FFFFFF)',
    },
    Tabs: {
      itemSelectedColor: 'var(--tab-selected-color, #0096E8)',
      colorBgContainer: 'inherit !important',
      titleFontSizeLG: '1rem',
      margin: 12,
      lineHeight: '2.15rem',
      cardPadding: '6px 0',
      cardPaddingLG: '6px 0',
      lineWidth: 0,
    },
    Input: {
      colorBgContainer: 'var(--select-bg-color, #2E3033)',
      borderRadius: 0,
      lineType: 'none',
      borderRadiusLG: 0,
      borderBottom: '1px solid #ccc',
      controlOutlineWidth: 0,
    },
    Select: {
      selectorBg: 'var(--select-bg-color, #2E3033)',
      colorText: 'var(--primary-text-color, #FFFFFF)',
      lineType: 'none',
      singleItemHeightLG: 48,
      borderRadiusLG: 0,
      colorBgElevated: 'var(--select-bg-color, #2E3033)',
      optionFontSize: 16,
      fontSize: 16,
      fontSizeLG: 16,
      fontSizeSM: 16,
      optionPadding: 10,
      optionActiveBg: 'var(--select-active-color, #232628)',
      controlOutlineWidth: 0,
      optionSelectedColor: 'var(--slider-bg-color, #000000)',
      colorBgContainerDisabled: 'var(--select-disabled-bg-color, #2E3033)',
    },
    Card: {
      borderRadiusLG: 0,
      fontWeightStrong: 700,
      colorBgContainer: 'var(--primary-fill-color, #1A1C1D)',
      colorBorderSecondary: '#71767C',
      headerFontSizeSM: 20,
      headerHeightSM: 48,
      boxShadow: 'transparent',
    },
    Typography: {
      titleMarginTop: 0,
      titleMarginBottom: '24px',
      colorError: '#FD5A5C',
      colorSuccess: '#86D7A2',
    },
    Timeline: {
      dotBg: 'var(--primary-fill-color, #1A1C1D)',
      dotBorderWidth: 0,
      tailColor: '#71767C',
      tailWidth: 1,
    },
    Dropdown: {
      colorBgElevated: 'var(--primary-fill-color, #1A1C1D)',
    },
    Modal: {
      headerBg: 'var(--modal-bg-color, #232628)',
      contentBg: 'var(--modal-bg-color, #232628)',
      footerBg: 'var(--modal-bg-color, #232628)',
    },
    DatePicker: {
      colorBgContainer: 'var(--select-active-color, #232628)',
      cellActiveWithRangeBg: '#007BC0',
      cellHoverWithRangeBg: '#007BC0',
      multipleItemBg: '#007BC0',
    },
    Slider: {
      controlSize: 20,
      railBg: 'var(--slider-bg-color,#000000)',
      railHoverBg: 'var(--slider-bg-color,#000000)',
      trackBg: 'var(--slider-track-bg-color,#EFF1F2)',
      trackHoverBg: 'var(--slider-track-bg-color,#EFF1F2)',
      dotActiveBorderColor: 'var(--slider-track-bg-color,#EFF1F2)',
      dotBorderColor: 'var(--slider-track-bg-color,#EFF1F2)',
      handleColor: 'var(--slider-track-bg-color,#EFF1F2)',
      handleActiveColor: 'var(--slider-track-bg-color,#EFF1F2)',
      handleLineWidth: 1,
      railSize: 8,
    },
    Breadcrumb: {
      itemColor: 'var(--primary-text-color, #FFFFFF)',
      separatorColor: 'var(--primary-text-color, #FFFFFF)',
    },
    Form: {
      itemMarginBottom: 24,
    },
    Alert: {
      colorErrorBg: '#7D0002',
      colorInfoBg: '#003E64',
      colorSuccessBg: '#219557',
      colorIcon: '#EFF1F2',
      colorIconHover: '#EFF1F2',
      fontSize: 16,
      fontSizeLG: 16,
      fontSizeIcon: 16,
      colorError: '#EFF1F2',
      colorInfo: '#EFF1F2',
      colorSuccess: '#EFF1F2',
    },
    Message: {
      boxShadow: 0,
      borderRadius: 0,
      borderRadiusLG: 0,
      borderRadiusSM: 0,
      colorError: '#EFF1F2',
      colorSuccess: '#EFF1F2',
      colorWarning: '#EFF1F2',
      colorText: '#EFF1F2',
    },
    Switch: {
      handleBg: 'var(--selected-text-color, #000000)',
      handleSize: 12,
      trackHeight: 24,
      trackMinWidth: 48,
      trackPadding: 6,
    },
    Radio: {
      buttonBg: 'var(--button-default-bg-color, #007BC0)',
      colorPrimary: 'var(--button-default-bg-color, #007BC0)',
      colorBgContainer: 'var(--radio-container-bg, #71767C)',
      colorBgContainerDisabled: 'var(--radio-container-disabled-bg, #1A1C1D)',
      radioSize: 18,
      dotSize: 9,
      fontSize: 16,
      colorBorder: 'transparent',
    },
    Statistic: {
      titleFontSize: '0.875rem',
      contentFontSize: '1.5rem',
      colorTextDescription: 'var(--primary-text-color, #fff)',
      colorBgContainer: 'red',
    },
    Tooltip: {
      colorBgSpotlight: 'var(--primary-fill-color, #1a1c1d)',
      colorTextLightSolid: 'var(--primary-text-color, #000000)',
    },
    Steps: {
      colorPrimary: '#0096E8',
      colorSplit: 'var(--stepper-split-bg-color, #8A9097)',
    },
    Checkbox: {
      colorBgContainer: '#8A9097',
      colorBorder: '#8A9097',
      colorPrimary: 'var(--button-default-bg-color, #007BC0)',
      colorText: 'var(--primary-text-color, #FFFFFF)',
    },
  },
  token: {
    fontSize: 16,
    fontSizeHeading1: 48,
    fontSizeHeading2: 40,
    fontSizeHeading3: 32,
    fontSizeHeading4: 24,
    fontSizeHeading5: 20,
    lineHeight: 1.5,
    lineHeightHeading1: 1.25,
    lineHeightHeading2: 1.3,
    lineHeightHeading3: 1.35,
    fontWeightStrong: 700,
    fontFamily: 'BoschSansRegular, sans-serif',
    colorText: 'var( --primary-text-color, #FFFFFF)',
    colorPrimaryBg: 'var(--body-bg-color, #000000)',
    colorPrimary: '#007bc0',
    colorInfo: '#007bc0',
    colorSuccess: '#00884a',
    colorError: '#ed0007',
    colorWarning: '#ffcf00',
    colorPrimaryText: '#56b0ff',
    borderRadius: 0,
    colorLink: 'var( --primary-text-color, #FFFFFF)',
    colorBgElevated: '#1A1C1D',
    colorBgSpotlight: '#1A1C1D',
  },
};

export default darkThemeConfig;
